var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var labelStyles = {
    root: function (_a) {
        var _b = _a.props, image = _b.image, imagePosition = _b.imagePosition, circular = _b.circular, variables = _a.variables;
        return (__assign({ padding: variables.padding }, (image &&
            imagePosition === 'start' && {
            paddingLeft: variables.startPaddingLeft,
        }), (image &&
            imagePosition === 'end' && {
            paddingRight: variables.endPaddingRight,
        }), { display: 'inline-flex', alignItems: 'center', height: variables.height, fontSize: pxToRem(14), lineHeight: variables.height, backgroundColor: variables.backgroundColor, color: variables.color, borderRadius: pxToRem(3) }, (circular && {
            borderRadius: variables.circularRadius,
        }), { overflow: 'hidden' }));
    },
    image: function (_a) {
        var variables = _a.variables;
        return ({
            height: variables.height,
            width: variables.height,
        });
    },
    icon: function (_a) {
        var props = _a.props;
        return (__assign({}, (props.icon &&
            typeof props.icon === 'object' &&
            props.icon.onClick && {
            cursor: 'pointer',
        })));
    },
};
export default labelStyles;
